import { ChangeEvent, useState } from 'react'
import { getFieldError, TInputValidator } from '../formInput/FormInput.utils'
import { HiOutlineCheck } from 'react-icons/hi'

interface IFormCheckbox {
  name: string
  label?: string
  description?: string
  wasSubmitted?: boolean
  validators?: TInputValidator[]
  className?: string
  initialValue: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

const SPACEBAR_KEY_CODE = 32

export function FormCheckbox({
  name,
  label,
  description,
  validators = [],
  wasSubmitted = false,
  className,
  initialValue = false,
  onChange = () => {},
}: IFormCheckbox) {
  const [value, setValue] = useState(initialValue)
  const [touched, setTouched] = useState(false)
  const errorMessage = getFieldError(value, validators)
  const displayErrorMessage = (wasSubmitted || touched) && errorMessage

  const handleChange = (event) => {
    setValue(!value)
    onChange(event)
  }

  const handleKeyPress = (event) => {
    if (event?.keyCode === SPACEBAR_KEY_CODE) {
      handleChange(event)
    }
  }

  return (
    <div
      className={`flex justify-start text-left relative transition-all mb-8 ${
        label ? 'flex-col' : 'flex-row'
      } ${className}`}
    >
      <input
        type="checkbox"
        id={name}
        name={name}
        defaultChecked={value}
        value={value.toString()}
        className="absolute w-0 h-0 peer -z-1"
        onChange={handleChange}
        onBlur={() => setTouched(true)}
        onKeyPress={(e) => handleKeyPress(e)}
      />

      <label
        htmlFor={name}
        className={`
                    flex select-none cursor-pointer text-acai text-lg
                    before:content-[''] before:border-2 ${
                      value
                        ? 'before:border-acai'
                        : 'before:border-core-grey-darker'
                    } before:w-8 before:h-8 before:block before:rounded-md before:mr-3
                    peer-focus:before:border-pitaya
                    ${displayErrorMessage && 'before:border-error'}
                    ${value && `before:bg-acai`}
                `}
      >
        <span className={description ? '' : 'mt-1'}>{label}</span>
        <HiOutlineCheck
          className={`text-white h-6 w-6 absolute top-1 left-1 ${
            value ? 'block' : 'hidden'
          }`}
        />
      </label>

      {description && (
        <p
          className={`text-lg select-none text-core-grey-dark ${
            label ? 'ml-11' : ''
          }`}
        >
          {description}
        </p>
      )}

      {displayErrorMessage && (
        <span
          role="alert"
          id={`${name}-error`}
          className="absolute left-0 pt-1 text-base text-left top-full text-core-error"
        >
          {errorMessage}
        </span>
      )}
    </div>
  )
}
